module.exports = __webpack_public_path__ + "static/media/pl-or-5.5a57b456.jpg";